export default function initAjaxForm() {

  // Alle relevanten Formulare auswählen
  const forms = document.querySelectorAll("form.ajax-form");
  forms.forEach(form => {
    // Container im jeweiligen Formular suchen
    const targetContainer = document.querySelector(form.dataset.content);
    if (!targetContainer) return;
    function submit() {
      // Formulardaten sammeln
      const formData = new FormData(form);

      // FormData → JSON
      const jsonData = {};
      formData.forEach((value, key) => {
        jsonData[key] = value;
      });
      // Fetch an form.action + ".json"
      fetch(form.action + ".json", {
        method: "POST",
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
          "Content-Type": "application/json"
        },
        body: JSON.stringify(jsonData)
      })
      .then(response => response.json())
      .then(data => {
        if (data.html) {
          targetContainer.innerHTML = data.html;
          // initAjaxForm()
        }
      })
      .catch(err => {
        console.error("Fehler beim AJAX-Formular:", err);
      });
    }

    form.addEventListener("submit", (e) => {
      e.preventDefault();
      submit()
    }, { once: true });
  });
};
